<template>
  <footer
    class="bg-card/95 backdrop-blur-sm border-t border-border/50 pt-16 pb-8"
    dir="rtl"
    style="background-color: #333333; color: white"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- بخش بالایی با گرید ساده‌تر -->
      <div
        class="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-8 lg:gap-12 mb-12"
        style="margin: 0"
      >
        <!-- ستون لوگو و توضیحات -->
        <div class="col-span-2 lg:col-span-2">
          <router-link to="/" class="flex items-center gap-2 mb-4 group">
            <div
              class="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm"
            >
              <img src="@/assets/logo-sazibaz.png" alt="logo" />
            </div>
            <span
              class="text-lg font-semibold text-foreground group-hover:text-primary transition-colors"
              >شاپیکام</span
            >
          </router-link>
          <p
            class="text-sm text-muted-foreground/80 leading-relaxed max-w-sm mb-4"
          >
            shopecom پلتفرمی یکپارچه برای ساخت وب‌سایت است. با استفاده از
            shopecom، همه می‌توانند با هر سطحی از دانش فنی، برای کسب‌وکار خود یک
            سایت بسازند و تنها با استفاده از پنل shopecom، سفارشات خود را از
            مرحله‌ی پرداخت تا ارسال و وفادارسازی مشتری مدیریت کنند. علاوه بر
            این، با استفاده از بسته‌های مکمل shopecom، هر کسب‌وکاری می‌تواند
            ترافیک سایت خود را افزایش دهد و ظاهری زیبا و چشم‌گیر برای سایت خود
            ایجاد کند.
          </p>
        </div>

        <!-- ستون‌های منو - مختصرتر -->
        <div>
          <h3 class="text-foreground font-medium text-sm mb-4">محصول</h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/builder"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >سازنده</router-link
              >
            </li>
            <li>
              <router-link
                to="/templates"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >قالب‌ها</router-link
              >
            </li>
            <li>
              <router-link
                to="/plane"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >قیمت‌ها</router-link
              >
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-foreground font-medium text-sm mb-4">منابع</h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/faq"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >سوالات متداول</router-link
              >
            </li>
            <li>
              <router-link
                to="/blog"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >وبلاگ</router-link
              >
            </li>
            <li>
              <router-link
                to="/support"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >پشتیبانی</router-link
              >
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-foreground font-medium text-sm mb-4">شرکت</h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/about"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >درباره ما</router-link
              >
            </li>
            <li>
              <router-link
                to="/contact"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >تماس</router-link
              >
            </li>
            <li>
              <router-link
                to="/features"
                class="text-xs text-muted-foreground hover:text-primary transition-colors"
                >فرصت‌ها</router-link
              >
            </li>
          </ul>
        </div>
        <!-- اینماد در ستون شرکت -->
        <div class="mt-4">
          <a
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=707798&Code=U4owlh4JauffML6dPnUsg1WHX45K7NFn"
          >
            <img
              referrerpolicy="origin"
              src="https://trustseal.enamad.ir/logo.aspx?id=707798&Code=U4owlh4JauffML6dPnUsg1WHX45K7NFn"
              alt="نشان اعتماد الکترونیکی اینماد"
              style="cursor: pointer; max-width: 100px"
              code="U4owlh4JauffML6dPnUsg1WHX45K7NFn"
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default { name: "AppFooter" };
</script>

<style>
.kodsaz {
  color: rgb(145, 12, 145);
}
</style>